module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Stardust.ad03c3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Stardust.jpg
// module id = g0fR
// module chunks = 0